const config = {
  apiUrl: "https://api.blueberrypiestaging.com/fbt/api/",
};
export default config;

const siteConfig = {
  siteName: "Blueberry Pie",
  siteIcon: "ion-flash",
  footerText: `Copyright ${new Date().getFullYear()}  Blueberry Pie LLC`,
};
const themeConfig = {
  topbar: "themedefault",
  sidebar: "themedefault",
  layout: "themedefault",
  theme: "themedefault",
};
const language = "english";
export { siteConfig, language, themeConfig };
